// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonWrapper } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@mcmc/XDL/Icons/Close";
import { xBaseTheme } from "@mcmc/XDL/types";
import { RobotoCondensed } from "@mcmc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            min-height: 0;
            padding: 10px;
            ${IconWrapper} {
                transition: color ease-in 250ms;
            }

            & > ${ButtonWrapper} {
                line-height: 0;
                background: transparent;
            }

            & > ${ButtonWrapper}:hover:not(:disabled) {
                background: transparent;
                ${IconWrapper} {
                    color: ${getColor("common.ui1")};
                }
            }
        `,
        iconProps: {
            src: Close,
            size: 13,
        },
        typographyProps: {
            ...RobotoCondensed,
            weight: "bold",
            size: 14,
            lineHeight: "16px",
            ellipsis: true,
            css: css`
                letter-spacing: 0.16px;
                margin-right: 5px;
                max-width: 200px;
            `,
        },
    },
} as xBaseTheme["tag"];
